<template>
  <b-card title="Configurações de Tradução">
    <b-alert
      show
      variant="primary"
    >
      <div class="alert-body">
        <feather-icon
          class="mr-25"
          icon="InfoIcon"
        />
        <span class="ml-25">Aqui você poderá configurar as traduções do sistema.</span>
      </div>
    </b-alert>
    <translation-config-core />
  </b-card>
</template>

<script>
import { BCard, BAlert } from 'bootstrap-vue'
import TranslationConfigCore from '@core/components/translation-config/TranslationConfig.vue'

export default {
  components: {
    BAlert,
    BCard,
    TranslationConfigCore
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", "Configurações de Tradução");
  },
}
</script>

<style>
</style>
